<template>
  <div class="form-group">
    <label
      for="position"
      class="mb-1"
    >
      {{ label }}
      <span
        v-if="sublabel"
        class="fw-normal"
      >
        {{ sublabel }}
      </span>
    </label>
    <div class="position-relative">
      <div
        class="input-group"
        @click="toggleSelect"
      >
        <input
          :disabled="disabled"
          :value="display"
          class="form-control cursor-pointer text-start bg-white custom-select"
          :class="[validationClass, { 'open': open },
                   { 'disabled-bg': disabled }]"
          readonly="true"
          :placeholder="placeholder"
        >
      </div>
      <transition
        name="slide"
        tag="div"
      >
        <div
          v-if="list.length > 0 && open"
          class="d-flex flex-column position-absolute w-100 pb-3"
          style="top: 56px"
        >
          <div
            class="bg-white w-100 custom-select-dropdown"
            style="max-height: 260px;"
          >
            <div
              v-for="(item, index) in list"
              :key="item.code + '-' + index"
              class="d-flex btn btn-block w-100 text-start font-weight-normal border-bottom"
              @click="setValue(item)"
            >
              <div class="my-auto text-left">
                {{ item.name || item.label }}
              </div>
            </div>
          </div>
        </div>
      </transition>
      <div
        v-if="list.length === 0 && open"
        class="position-absolute bg-white w-100 rounded-4 p-2"
        style="border: 2px solid #BFC9D6; z-index: 10; bottom: -60px"
      >
        aucun résultat
      </div>
    </div>
  </div>
</template>
<script>
import input from '@/mixins/input-2';

export default {
  name: 'InputSelectTwo',
  mixins: [input],
  props: {
    list: {
      type: Array,
      required: true,
      default: () => [],
    },
    sublabel: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['input'],
  data() {
    return {
      open: false,
    };
  },
  computed: {
    display() {
      const search = ({ code }) => code === this.customValue;
      if (this.list.some(search)) {
        const find = this.list.find(search);
        return find.name || find.label;
      }
      if (this.customValue && this.customValue.name) {
        return this.customValue.name;
      }
      if (this.customValue && this.customValue.label) {
        return this.customValue.label;
      }
      return null;
    },
  },
  methods: {
    setValue(item) {
      this.open = false;
      this.setCustomModel(item);
      this.$emit('input', item);
    },
    toggleSelect() {
      if (this.disabled) return;
      this.open = !this.open;
    }
  }
};
</script>

<style scoped>

.disabled-bg {
  background-color: #e9ecef !important;
}
.custom-select-dropdown {
  border: 2px solid #BFC9D6;
  border-radius: 15px;
  z-index: 100;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
}
.btn-block {
  border-radius: 0;
  min-height:60px;
}
.btn-block:hover{
  background-color: #EDF4FD;
}
.btn-block + .btn-block {
  margin-top: 0;
}
.btn-block:focus{
  box-shadow: none;
  border-radius: 8px;
}
</style>
